import { Routes, Route } from 'react-router-dom';
import loadable from '@loadable/component';
import AuthProvider from '../../providers/auth.provider';
import CheckCMSNewVersionLayer from '../../components/layout/CheckCMSNewVersionLayer';
import { config } from '../../config';

const liffId = config.liff_id.regisAutoDebit;

const AutoDirectDebitMethod = loadable(
  () => import('./AutoDirectDebitMethod'),
  { fallback: null },
);

const AutoDirectDebitBankAccount = loadable(
  () => import('./AutoDirectDebitBankAccount'),
  { fallback: null },
);

const BankAccountProductType = loadable(
  () => import('./BankAccountProductTypes'),
  { fallback: null },
);

const AutoDirectDebitCreditCardPolicyList = loadable(
  () => import('./AutoDirectDebitCreditCardPolicyList'),
  { fallback: null },
);

const AutoDirectDebitCreditCardConsent = loadable(
  () => import('./AutoDirectDebitCreditCardConsent'),
  { fallback: null },
);

const AutoDirectDebitCreditCardForm = loadable(
  () => import('./AutoDirectDebitCreditCardForm'),
  { fallback: null },
);

const AutoDirectDebitCreditCardOTP = loadable(
  () => import('./AutoDirectDebitCreditCardOTP'),
  { fallback: null },
);

const AutoDirectDebitCreditCardComplete = loadable(
  () => import('./AutoDirectDebitCreditCardComplete'),
  { fallback: null },
);

const NotFound = loadable(() => import('../NotFound'), { fallback: null });

export default function AutoDirectDebitRoute() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <AuthProvider liffId={liffId}>
            <CheckCMSNewVersionLayer>
              <AutoDirectDebitMethod />
            </CheckCMSNewVersionLayer>
          </AuthProvider>
        }
      />
      <Route path="bank-account" element={<AutoDirectDebitBankAccount />} />
      <Route
        path="bank-account/product-types"
        element={<BankAccountProductType />}
      />
      <Route
        path="credit-card/policies"
        element={<AutoDirectDebitCreditCardPolicyList />}
      />
      <Route
        path="credit-card/tc"
        element={<AutoDirectDebitCreditCardConsent />}
      />
      <Route
        path="credit-card/form"
        element={<AutoDirectDebitCreditCardForm />}
      />
      <Route
        path="credit-card/otp"
        element={<AutoDirectDebitCreditCardOTP />}
      />
      <Route
        path="credit-card/complete"
        element={<AutoDirectDebitCreditCardComplete />}
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
